import React from "react";
import {
  Col,
  FormGroup,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from "reactstrap";
import { Button, TextField } from "shared";
import {
  SelectionElementItemProps,
  SiteComparisonSelectionProps,
} from "./type";

const SelectionElementItem = ({
  item,
  onSelected,
}: SelectionElementItemProps) => {
  const handleElementSelected = () => {
    if (onSelected) {
      onSelected();
    }
  };
  return (
    <Col xs={12}>
      <div className="site-comparison__selection-item-wrapper">
        <div className="site-comparison__selection-item-info">
          <p className="site-comparison__selection-item__name">{item.name}</p>
          <p className="site-comparison__selection-item__address">
            {item.full_address}
          </p>
        </div>
        <div className="site-comparison__selection-item-controls">
          <Button
            type="primary"
            outline
            label="Chọn"
            onClick={handleElementSelected}
            size="small"
          />
        </div>
      </div>
    </Col>
  );
};

const SiteComparisonSelection = ({
  showSelectionModal,
  toggleSelectionModal,
  siteNameKeywords,
  siteNameKeywordsHandler,
  storeNameKeywords,
  storeNameKeywordsHandler,
  toggleCompetitorSelectionModal,
  sites = [],
  stores = [],
  addSiteForComparison,
  addStoreForComparison,
}: SiteComparisonSelectionProps) => {
  return (
    <Modal size="lg" isOpen={showSelectionModal} toggle={toggleSelectionModal}>
      <ModalHeader toggle={toggleSelectionModal}>
        Chọn mặt bằng / cửa hàng để so sánh
      </ModalHeader>
      <ModalBody>
        <Row>
          <Col xs={12} sm={6}>
            <FormGroup>
              <Label>Tìm mặt bằng</Label>
              <TextField
                value={siteNameKeywords}
                type="outline"
                placeholder="Tìm mặt bằng theo tên..."
                icon="search"
                onChange={siteNameKeywordsHandler}
              />
            </FormGroup>
          </Col>
          <Col xs={12} sm={6}>
            <FormGroup>
              <Label>Tìm cửa hàng</Label>
              <TextField
                value={storeNameKeywords}
                type="outline"
                placeholder="Tìm store theo tên..."
                icon="search"
                onChange={storeNameKeywordsHandler}
              />
            </FormGroup>
          </Col>
          <Col xs={12} sm={6}>
            <Button
              type="primary"
              label="Chọn đối thủ? Nhấn vào đây"
              onClick={(evt) => {
                toggleCompetitorSelectionModal();
                toggleSelectionModal(evt);
              }}
              size="small"
            />
          </Col>
        </Row>
        <Row>
          {sites.map((site) => (
            <SelectionElementItem
              key={`${site.type}-${site.id}`}
              item={site}
              onSelected={() => addSiteForComparison(site)}
            />
          ))}
        </Row>
        <Row>
          {stores.map((store) => (
            <SelectionElementItem
              key={`${store.type}-${store.id}`}
              item={store}
              onSelected={() => addStoreForComparison(store)}
            />
          ))}
        </Row>
      </ModalBody>
      <ModalFooter>
        <Button
          type="default"
          outline
          label="Huỷ"
          onClick={toggleSelectionModal}
          size="small"
        />
      </ModalFooter>
    </Modal>
  );
};

export default SiteComparisonSelection;
